import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { interval, Subject, timer } from 'rxjs';
import { map, mapTo, scan, takeUntil, takeWhile } from 'rxjs/operators';

import { fadeInAndOut, textFadeSlide } from '@shared/animations/shared.animations';

export enum SpinnerSteps {
  START,
  DISLIKE,
  LIKE,
  FINISH
}

@Component({
  selector: 'app-dialog-portfolio-spinner',
  templateUrl: './dialog-portfolio-spinner.component.html',
  styleUrls: ['./dialog-portfolio-spinner.component.scss'],
  animations: [
    fadeInAndOut('elementFade'),
    fadeInAndOut('containerFade', 'cubic-bezier(0.25, 0.8, 0.25, 1)', '270ms', '270ms'),
    textFadeSlide('textFade', 300, { opacity: 1 }, { opacity: 0 }, 'show <=> hide', 'cubic-bezier(0.25, 0.8, 0.25, 1)'),
    textFadeSlide(
      'textSlideExit',
      320,
      { transform: 'translateX(0)', opacity: 1 },
      { transform: 'translateX(-30px)', opacity: 0 },
      '* => hide',
      'cubic-bezier(0.25, 0.8, 0.25, 1)'
    ),
    textFadeSlide(
      'textSlideEnter',
      260,
      { transform: 'translateX(0)', opacity: 1 },
      { transform: 'translateX(30px)', opacity: 0 },
      '* => show',
      'cubic-bezier(0.25, 0.8, 0.25, 1)'
    )
  ],
  standalone: false
})
export class DialogPortfolioSpinnerComponent implements OnInit, OnDestroy {
  @Input() showSpinner: boolean;
  @Input() dataLoading: boolean;
  @Input() numberOfCompanies: number;
  @Input() isEve2: boolean;
  @Output() closeLoader: EventEmitter<boolean> = new EventEmitter<boolean>();
  spinnerSteps = SpinnerSteps;
  activeStep: SpinnerSteps;
  stopSteps = false;
  seconds = 0;
  companyLogos: string[] = ['stadler', 'nibe', 'tomra', 'oatly', 'evoqua', 'edp', 'gsk', 'firstsolar', 'ltg', 'orsted'];

  protected readonly onDestroy$ = new Subject<void>();

  ngOnInit(): void {
    this.runSpinnerSteps();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  runSpinnerSteps(): void {
    this.activeStep = SpinnerSteps.START;
    interval(6000)
      .pipe(
        map((value) => value + 1),
        takeWhile(() => !this.stopSteps),
        takeUntil(this.onDestroy$)
      )
      .subscribe((count) => {
        if (!this.dataLoading && count > 2) {
          this.runFinishStep();
          return;
        }
        if (this.activeStep === SpinnerSteps.LIKE) {
          this.activeStep = 0;
          return;
        }
        if (this.isEve2) {
          return;
        }
        this.activeStep += 1;
      });
  }

  runFinishStep(): void {
    this.stopSteps = true;
    this.activeStep = SpinnerSteps.FINISH;
    timer(0, 1000)
      .pipe(
        mapTo(-1),
        scan((acc, value) => {
          return acc + value;
        }, 7),
        takeWhile((value) => value >= 0),
        takeUntil(this.onDestroy$)
      )
      .subscribe((value) => {
        this.seconds = value;
        if (value === 0) {
          this.closeLoader.emit(false);
        }
      });
  }

  toggleAnimation(spinnerStep: SpinnerSteps): string {
    return this.activeStep === spinnerStep ? 'show' : 'hide';
  }

  onCloseLoader(): void {
    this.closeLoader.emit(true);
  }
}
